import { RightOutlined } from "@ant-design/icons";
import {

    Row,
    Col,

    Button,

    Form,
    Input,

    Select,

    Radio,

    Space,


} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { addOccupation } from '../../../store/occupationSlice';

import occupationService from "../../../api/occupation.service";






import { EDIT_MODE, SUCCESS_STATUS } from "../../../utility/Constants";
import CustomMessage from "../../common/CustomMessage";
import { addTimeSlot } from "../../../store/timeslotSlice";
import commonUtility from "../../../utility/Utils";
const { Option } = Select;






const OccupationEntry = ( {data , onDrawerClose} ) => {
    // console.log(data)
    const [isFormResponse, setIsFormResponse] = useState(false);
    const [formResponseMessage, setFormResponseMessage] = useState("");
    const [formResponseStatus, setFormResponseStatus] = useState("");

    const dispatch = useDispatch();



    const [formDefaultValues, setFormDefaultValues] = useState({
        id: data.id,
        occupation_name: data.occupation_name,
        mode: data.mode
    });

    const [mode, setMode] = useState(data.mode);


    const [form] = Form.useForm();

    
    const onOccupationSave = async (values) => {
        const data = { formdata: values };
        console.log(data);
        
        const response = occupationService.save(data).then((resdata) => {
            setIsFormResponse(true);
            setFormResponseStatus(resdata.response_status);
            setFormResponseMessage(resdata.response_msg);
            const x = {
                id:commonUtility.randomID(),
                occupation_name:values.occupation_name
            }
            dispatch(addOccupation(x))
        });
    };
 



    const hideResponseMessage = () => {
        setIsFormResponse(false);
        if(mode == "ADD") {
            form.resetFields();
            form.setFieldsValue({
                id: formDefaultValues.id,
                mode: data.mode
            })
        }
        
    }


    useEffect(() => {


        mode == EDIT_MODE ?

            form.setFieldsValue({
                id: formDefaultValues.id,
                occupation_name: formDefaultValues.occupation_name,
                mode: data.mode

            })
            :
            form.setFieldsValue({
                id: 0,
                occupation_name: '',
                mode: data.mode
            });


        form.setFieldsValue(formDefaultValues)

    }, [form]);







    return (
        <div>
            <div className="form-input-style">

                <Row className="" style={{ background: "transparent" }}>
                    <Col className="" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onOccupationSave}
                            autoComplete="off"
                        // initialValues={formDefaultValues}
                        >

                            {/* <Row gutter={20}>
                         <Col className="gutter-row" xs={24} xl={24}>
                             <h5>Note: * fields are required</h5>
                         </Col>
                     </Row> */}
                            <Row gutter={20}>
                                <Col className="gutter-row" xs={24} xl={12}>

                                    <Form.Item name="occupation_name" label="Occupation" rules={[
                                        {
                                            required: true,
                                            message: 'Occupation is required',
                                        },
                                    ]}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item name="id" label="id" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                    <Form.Item name="mode" label="mode" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>

                              





                                <Col xs={24} xl={12}>
                                    <Form.Item name="" label=" ">
                                        <Space>

                                            <Button className="custom-button-green" htmlType="submit">
                                                Save <RightOutlined />
                                            </Button>
                                        </Space>
                                    </Form.Item>
                                </Col>


                            </Row>
                        </Form>



                    </Col>
                </Row>
                {
                    //isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} /> : ''
                    isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} onDrawerClose={onDrawerClose} mode={form.getFieldValue('mode')} /> : ''
                }




            </div>
        </div>
    );
}

export default OccupationEntry